// extracted by mini-css-extract-plugin
export default {"premium-top":"PrimePageTop_premium-top__cnDmx","btns":"PrimePageTop_btns__ejPBG","link":"PrimePageTop_link__LjnLN"};